import type { ChipVariant } from "@/components/ui/chip"
import { routes } from "@/constants/routes"
import {
  AssistantIcon,
  CasinoIcon,
  CrownIcon,
  FaqIcon,
  HistoryIcon,
  PromotionsIcon,
  ResponsibleIcon,
  SportsIcon,
  TrophyIcon,
  UserIcon,
  UsersIcon,
  WalletIcon,
  type IconComponent
} from "@/src/shared/assets/icons"

import { texts } from "./localization/texts"

export type SidebarSectionId = keyof typeof texts.sections

export type SidebarRowId = keyof typeof texts.rows

export type SidebarBadgeDef =
  | {
      variant: Exclude<ChipVariant, "count">
      textKey: keyof typeof texts.badges
    }
  | { variant: "count"; value: number }

export type SidebarRowDef = {
  id: SidebarRowId
  href: string | null
  icon: IconComponent
  badge?: SidebarBadgeDef
}

export type SidebarSectionDef = {
  id: SidebarSectionId
  rows: readonly SidebarRowDef[]
}

export const SIDEBAR_SECTIONS: readonly SidebarSectionDef[] = [
  {
    id: "play",
    rows: [
      { id: "sports", href: routes.SPORTS, icon: SportsIcon },
      { id: "casino", href: routes.CASINO, icon: CasinoIcon },
      {
        id: "tournaments",
        href: routes.TOURNAMENTS,
        icon: TrophyIcon,
        badge: { variant: "comingSoon", textKey: "pronto" }
      }
    ]
  },
  {
    id: "rewards",
    rows: [
      { id: "vip", href: routes.VIP, icon: CrownIcon },
      {
        id: "promotions",
        href: routes.PROMOTIONS,
        icon: PromotionsIcon,
        badge: { variant: "count", value: 10 }
      },
      {
        id: "referrals",
        href: routes.REFERALS,
        icon: UsersIcon,
        badge: { variant: "bonus", textKey: "ganaL100" }
      }
    ]
  },
  {
    id: "account",
    rows: [
      {
        id: "profile",
        href: routes.DASHBOARD,
        icon: UserIcon,
        badge: { variant: "verify", textKey: "verifica13" }
      },
      { id: "withdrawals", href: routes.WITHDRAWALS, icon: WalletIcon },
      { id: "history", href: routes.TRANSACTIONS, icon: HistoryIcon }
    ]
  },
  {
    id: "help",
    rows: [
      {
        id: "assistant",
        href: null,
        icon: AssistantIcon,
        badge: { variant: "live", textKey: "live247" }
      },
      { id: "faq", href: routes.INFO_FAQ, icon: FaqIcon },
      {
        id: "responsible",
        href: routes.INFO_RESPONSIBILITY,
        icon: ResponsibleIcon
      }
    ]
  }
]
